import React, { Fragment, useEffect, useState } from 'react';
import './ColorKeys.scss';
import Key from './Key';

function ColorKeys({ colorKeyContent }) {
  const [colorKey, setColorKey] = useState();
  useEffect(() => {
    const temp = [[], []];
    colorKeyContent.forEach((key, i) => {
      if ((colorKeyContent.length < 5 && i > 1) || (colorKeyContent.length === 5 && i > 2)) {
        temp[1].push(key);
      } else {
        temp[0].push(key);
      }
    });
    setColorKey(temp);
  }, [colorKeyContent]);

  return (
    <section className="colorKey">
      <div className="colorKey__content colorKey__content__desktop">
        {colorKeyContent.map((content, i) => {
          return (
            <Fragment key={i}>
              <Key content={content} i={i} />
              {colorKeyContent[i + 1] ? <div className="colorKey__divider" /> : <></>}
            </Fragment>
          );
        })}
      </div>
      {colorKey ? (
        colorKey.map((contents, index) => {
          return (
            <Fragment key={index}>
              <div className="colorKey__content colorKey__content__mobile">
                {contents.map((content, i) => {
                  return (
                    <Fragment key={i}>
                      <Key content={content} i={i} />
                      {contents[i + 1] ? <div className="colorKey__divider" /> : <></>}
                    </Fragment>
                  );
                })}
              </div>

              {colorKey[index + 1] ? <div className="colorKey__divider__horizontal" /> : <></>}
            </Fragment>
          );
        })
      ) : (
        <></>
      )}
    </section>
  );
}

export default ColorKeys;
